const getParentNode = (prevSelectedNode, selectedNode, slVueTree) => {
    let isParent = false;
    if (prevSelectedNode && prevSelectedNode.children.length > 0) {
        const prevSelectedNodeIds = prevSelectedNode.children.map(child => child.data.id);
        if (prevSelectedNodeIds.indexOf(selectedNode.data.id) > -1) {
            isParent = true;
        }
    }
    if (isParent) {
        return prevSelectedNode;
    }

    if (prevSelectedNode && prevSelectedNode) {
        return getParentNode(slVueTree.getPrevNode(prevSelectedNode.path), selectedNode, slVueTree);
    }

    return null;
};

const getNodeSiblings = (selectedNode, slVueTree) => {
    const nextSelectedNode = slVueTree.getNextNode(selectedNode.path);
    const prevSelectedNode = slVueTree.getPrevNode(selectedNode.path);
    const parentNode = getParentNode(prevSelectedNode, selectedNode, slVueTree);
    const parent_id = parentNode ? parentNode.data.id : null;
    const selectedNodeChildren = selectedNode.children;

    let sibling_id = nextSelectedNode ? nextSelectedNode.data.id : null;

    // find sibling of node with children -> last child + nextNode
    if (selectedNodeChildren.length > 0) {
      const lastChild = slVueTree.getNextNode(selectedNodeChildren[selectedNodeChildren.length - 1].path);
      sibling_id = lastChild.data.id;
    }
    if (parent_id === sibling_id) {
      sibling_id = null;
    }

    return {
        parentNode,
        parent_id,
        sibling_id,
    };
};

export {
    getParentNode,
    getNodeSiblings
};
